import type { CurrenciesMap, ValuesMap, LangsFormatMap } from "./dynamicVariables.d";

export const currenciesMap: CurrenciesMap = {
  USD: "$",
  EUR: "€",
  US$: "US$",
  "$ US": "$ US",
  GBP: "£",
  euro: "euro",
  евро: "евро",
  BRL: "R$",
  欧元: "欧元",
  USDtr: "USD",
  dollarRu: "долл. США",
  美元: "美元",
  dollar: "dollar",
};

export const langsFormatMap: LangsFormatMap = {
  "en-int,en,en-gb,en-ie,en-au,en-nz,en-in,en-ca": { format: "<currency><value>", separator: "," },
  bg: { format: "<value> <currency>", separator: "," },
  "pt-br,nl": { format: "<currency> <value>", separator: "." },
  "de,de-at,de-ch,ro,el,it,ro-md,tr": { format: "<value> <currency>", separator: "." },
  "fi,sv,hu,fr-ca": { format: "<value> <currency>", separator: " " },
  fallback: { format: "<value> <currency>", separator: "" },
};

export const valuesMap: ValuesMap = {
  "{{compensation_value}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-nz,en-au": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 10000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{luggage_compensation_value}}": {
    en: { value: 1700, currency: "USD" },
    "en-gb": { value: 1200, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 1700, currency: "US$" },
    "fr-ca": { value: 1700, currency: "$ US" },
    "pt-br": { value: 9000, currency: "BRL" },
    ru: { value: 1400, currency: "евро" },
    nb: { value: 1400, currency: "euro" },
    "zh-cn": { value: 1400, currency: "欧元" },
    fallback: { value: 1400, currency: "EUR" },
  },
  "{{extra_expenses_compensation_value}}": {
    en: { value: 7000, currency: "USD" },
    "en-gb": { value: 5300, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 7000, currency: "US$" },
    "fr-ca": { value: 7000, currency: "$ US" },
    "pt-br": { value: 39000, currency: "BRL" },
    nb: { value: 6000, currency: "euro" },
    ru: { value: 6000, currency: "евро" },
    "zh-cn": { value: 6000, currency: "欧元" },
    fallback: { value: 6000, currency: "EUR" },
  },
  "{{commission_value}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 10000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{ec261_compensation}}": {
    en: { value: 700, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "en-ca,en-in,en-au,en-nz": { value: 700, currency: "US$" },
    "fr-ca": { value: 700, currency: "$ US" },
    "pt-br": { value: 3000, currency: "BRL" },
    nb: { value: 600, currency: "euro" },
    "zh-cn": { value: 600, currency: "欧元" },
    ru: { value: 600, currency: "евро" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{brazil_compensation}}": {
    en: { value: 1800, currency: "USD" },
    "en-gb": { value: 1500, currency: "GBP" },
    "en-in,en-ca,en-au,en-nz": { value: 1800, currency: "US$" },
    "pt-br": { value: 10000, currency: "BRL" },
    "fr-ca": { value: 1800, currency: "$ US" },
    nb: { value: 1800, currency: "euro" },
    ru: { value: 1800, currency: "евро" },
    "zh-cn": { value: 1800, currency: "欧元" },
    fallback: { value: 1800, currency: "EUR" },
  },
  "{{uk261_compensation}}": {
    en: { value: 600, currency: "USD" },
    "en-gb": { value: 520, currency: "GBP" },
    "pt-br": { value: 3000, currency: "BRL" },
    "en-ca,en-in,en-au,en-nz": { value: 600, currency: "US$" },
    "fr-ca": { value: 600, currency: "$ US" },
    nb: { value: 600, currency: "euro" },
    ru: { value: 600, currency: "евро" },
    "zh-cn": { value: 600, currency: "欧元" },
    fallback: { value: 600, currency: "EUR" },
  },
  "{{passengers_compensated}}": {
    fallback: { value: "2" },
  },
  "{{br_flight_delay}}": {
    fallback: { value: "2" },
  },
  "{{nr_airhelpers}}": {
    fallback: { value: "400" },
  },
  "{{nr_languages}}": {
    fallback: { value: "18" },
  },
  "{{nr_ahp_purchases}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz,zh-cn": { value: "4.9" },
    fallback: { value: "4,9" },
  },
  "{{nr_flights_checked}}": {
    fallback: { value: "15" },
  },
  "{{goodwill_price}}": {
    "fr,pt-pt,da,el,it,pl,ro,fi,bg,cs,hu,ro-md": { value: 29.99, currency: "USD" },
    "fr-ca": { value: 29.99, currency: "$ US" },
    "zh-cn": { value: 29.99, currency: "美元" },
    tr: { value: 29.99, currency: "USDtr" },
    ru: { value: 29.99, currency: "dollarRu" },
    nb: { value: 29.99, currency: "dollar" },
    fallback: { value: 29.99, currency: "US$" },
  },
  "{{minimum_extra_expenses}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 200, currency: "EUR" },
    "zh-cn": { value: 200, currency: "欧元" },
    nb: { value: 200, currency: "euro" },
    ru: { value: 200, currency: "евро" },
    fallback: { value: 200, currency: "EUR" },
  },
  "{{airpayout_payout}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 100, currency: "EUR" },
    "zh-cn": { value: 100, currency: "欧元" },
    nb: { value: 100, currency: "euro" },
    ru: { value: 100, currency: "евро" },
    fallback: { value: 100, currency: "EUR" },
  },
  "{{ah_essential_price}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 24.99, currency: "EUR" },
    "zh-cn": { value: 24.99, currency: "欧元" },
    nb: { value: "24,99", currency: "euro" },
    ru: { value: "24,99", currency: "евро" },
    fallback: { value: "24,99", currency: "EUR" },
  },
  "{{ah_from_price}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 24.99, currency: "EUR" },
    "zh-cn": { value: 24.99, currency: "欧元" },
    nb: { value: "24,99", currency: "euro" },
    ru: { value: "24,99", currency: "евро" },
    fallback: { value: "24,99", currency: "EUR" },
  },
  "{{ah_complete_price}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 49.99, currency: "EUR" },
    "zh-cn": { value: 49.99, currency: "欧元" },
    nb: { value: "49,99", currency: "euro" },
    ru: { value: "49,99", currency: "евро" },
    fallback: { value: "49,99", currency: "EUR" },
  },
  "{{ah_complete_effective}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 4.17, currency: "EUR" },
    "zh-cn": { value: 4.17, currency: "欧元" },
    nb: { value: "4,17", currency: "euro" },
    ru: { value: "4,17", currency: "евро" },
    fallback: { value: "4,17", currency: "EUR" },
  },
  "{{ah_essential_effective}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 2.08, currency: "EUR" },
    "zh-cn": { value: 2.08, currency: "欧元" },
    nb: { value: "2,08", currency: "euro" },
    ru: { value: "2,08", currency: "евро" },
    fallback: { value: "2,08", currency: "EUR" },
  },
  "{{coral_campaign_commission_value}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { currency: "EUR" },
    "zh-cn": { currency: "欧元" },
    nb: { currency: "euro" },
    ru: { currency: "евро" },
    fallback: { currency: "EUR" },
  },
  "{{airluggage_payout}}": {
    "en-gb,en-ie,en,en-int,en-ca,en-in,en-au,en-nz": { value: 150, currency: "EUR" },
    "zh-cn": { value: 150, currency: "欧元" },
    nb: { value: "150", currency: "euro" },
    ru: { value: "150", currency: "евро" },
    fallback: { value: "150", currency: "EUR" },
  },
  "{{ahp_lounges}}": {
    fallback: { value: 1100 },
  },
  "{{reported_5_star_trustpilot}}": {
    "fr,pt-pt,es,nb,pl,ru,cs,bg": { value: "125 000" },
    da: { value: "125.000" },
    fallback: { value: 125000 },
  },
  "{{website_users}}": {
    fallback: { value: 77 },
  },
  "{{social_followers}}": {
    fallback: { value: 1 },
  },
  "{{airpayout_average}}": {
    fallback: { value: 11 },
  },
  "{{airluggage_average}}": {
    fallback: { value: 14 },
  },
  "{{loungepass_total}}": {
    "fr,pt-pt,es,nb,pl,ru,cs,bg": { value: "19 000" },
    da: { value: "19.000" },
    fallback: { value: 19000 },
  },
};
